import { gql } from "@apollo/client";

export const GET_PACKAGES = gql`
  query getPackages($catUID: String!) {
    products(
      filter: { category_uid: { eq: $catUID } }
      sort: { ln_sl_product_priority: ASC }
      pageSize: 40
      currentPage: 1
    ) {
      total_count
      items {
        id
        uid
        name
        type_id
        sku
        stock_status
        __typename
        short_description {
          html
          __typename
        }
        description {
          html
          __typename
        }
        ln_sl_inclusion_overview
        ln_sl_is_most_popular
        ln_sl_lexis_ai_package
        ln_sl_usc_feature_pdf
        ln_sl_lexis_ai_price_info
        ln_sl_lexis_ai_cta
        ... on BundleProduct {
          dynamic_sku
          dynamic_price
          dynamic_weight
          price_view
          ship_bundle_items
          items {
            uid
            option_id
            title
            sku
            type
            required
            position
            options {
              uid
              id
              label
              quantity
              can_change_quantity
              price
              price_type
              is_default
              position
              product {
                name
                sku
              }
              __typename
            }
            __typename
          }
          __typename
        }
        ... on CustomizableProductInterface {
          options {
            uid
            title
            required
            sort_order
            option_id
            ... on CustomizableDropDownOption {
              drop_down_option: value {
                uid
                option_type_id
                sku
                price
                price_type
                title
                sort_order
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
      }
      __typename
    }
  }
`;

export const GET_VIRTUAL_PACKAGES = gql`
  query getPackages($catUID: String!) {
    products(
      filter: { category_uid: { eq: $catUID } }
      sort: { ln_sl_product_priority: ASC }
      pageSize: 40
      currentPage: 1
    ) {
      total_count
      items {
        id
        uid
        name
        type_id
        sku
        stock_status
        __typename
        short_description {
          html
          __typename
        }
        description {
          html
          __typename
        }
        ln_sl_inclusion_overview
        ln_sl_is_most_popular
        ln_sl_usc_feature_pdf
        ... on BundleProduct {
          dynamic_sku
          dynamic_price
          dynamic_weight
          price_view
          ship_bundle_items
          items {
            uid
            option_id
            title
            sku
            type
            required
            position
            options {
              uid
              id
              label
              quantity
              can_change_quantity
              price
              price_type
              is_default
              position
              product {
                name
                sku
              }
              __typename
            }
            __typename
          }
          __typename
        }
        ... on CustomizableProductInterface {
          options {
            uid
            title
            required
            sort_order
            option_id
            ... on CustomizableDropDownOption {
              drop_down_option: value {
                uid
                option_type_id
                sku
                price
                price_type
                title
                sort_order
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
      }
      __typename
    }
  }
`;

 
